module.exports = __webpack_public_path__ + "media/images/application2/Package__bottom__handle-5caa646627e3b2adee5ad8ec0cd5e0c8.svg";